import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { HiOutlineMenu } from "react-icons/hi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { contact_details, menuItems } from "../../Assets/assests.js";
import call_us from "../../Assets/Icons/Navbar/call_us.png";
import mail_us from "../../Assets/Icons/Navbar/mail_us.png";
// import logo from "../../Assets/Logos/afsa_logo.jpeg";
import logo from "../../Assets/Logos/logo.jpg";
import { useApp } from "../../context/AppContext";
import axiosInstance from "../../utils/axios.js";
import PrimaryButton from "../common/PrimaryButton.jsx";
import UserLoginModal from "../user/Modal/UserLoginModal.jsx";

const MidBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [mobileActiveDropdown, setMobileActiveDropdown] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [services, setServices] = useState([]);
  const [userData, setUserData] = useState({});
  const [specialCampId, setSpecialCampId] = useState("");
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { contact } = useApp();
  const location = useLocation();

  const getCampaignData = async () => {
    try {
      const response = await axiosInstance.get("/campaigns/all-campaigns");
      setCampaigns(response.data);
    } catch (error) {
      console.error("Error fetching campaigns for dropdown:", error);
    }
  };

  const getServicesData = async () => {
    try {
      const response = await axiosInstance.get("/services/all-services");
      setServices(response.data);
    } catch (error) {
      console.error("Error fetching services for dropdown:", error);
    }
  };

  useEffect(() => {
    if (campaigns.length > 0) {
      const specialCamp = campaigns.find((camp) => camp.isSpecial === true);
      if (specialCamp) setSpecialCampId(specialCamp._id);
    }
  }, [campaigns]);

  useEffect(() => {
    getCampaignData();
    getServicesData();
  }, []);

  // Disable background scroll when mobile menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [menuOpen]);

  useEffect(() => {
    const token = localStorage.getItem("ngo-afsa-token");
    const user = JSON.parse(localStorage.getItem("ngo-afsa-data") || "{}");
    setIsLoggedIn(!!token);
    setUserData(user);
  }, [isLoginModalOpen]);

  const handleLogout = () => {
    localStorage.removeItem("ngo-afsa-token");
    localStorage.removeItem("ngo-afsa-data");
    setIsLoggedIn(false);
    navigate("/");
  };

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
    setMobileActiveDropdown(null);
    window.scrollTo(0, 0);
  };

  const handleMobileDropdownToggle = (index) => {
    setMobileActiveDropdown(mobileActiveDropdown === index ? null : index);
  };

  const handleGiveForACauseClick = () => {
    navigate(`/campaigns/${specialCampId}`);
  };

  // Active checks
  const isMenuItemActive = (item) => {
    if (item.path === location.pathname) return true;
    if (item.hasDropdown && item.dropdown) {
      return item.dropdown.some(
        (dropdownItem) => dropdownItem.path === location.pathname
      );
    }
    if (item.title === "Campaigns") {
      return true;
    }
    if (item.title === "Our Work") {
      return true;
    }
    return false;
  };

  // const isDropdownItemActive = (path) => location.pathname === path;
  const isCampaignActive = (campaignId) =>
    location.pathname === `/campaign/${campaignId}`;
  const isServiceActive = (serviceId) => location.pathname === `${serviceId}`;

  return (
    <div className="bg-white shadow-md overflow-hidden">
      {/* ---- Top Bar ---- */}
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-row items-center justify-between h-full">
          {/* Logo */}
          {/* <Link to={"/"} className="flex-shrink-0 ">
            <img
              src={logo}
              alt="AFSA Logo"
              className="h-12 w-auto sm:h-16 md:h-20 scale-150 sm:scale-150 pl-4 transition-all duration-200"
            />
          </Link> */}
          <Link to={"/"} className="flex-shrink-0 ">
            <img
              src={logo}
              alt="AFSA Logo"
              className="h-12 w-auto sm:h-16 md:h-20 pl-4 transition-all duration-200"
            />
          </Link>
          {/* Desktop Right Side */}
          <div className="hidden lg:flex flex-row items-center space-x-6">
            {/* Call */}
            <div className="flex items-center space-x-2 text-gray-600 text-sm md:text-base">
              <img
                className="w-5 h-5 md:w-6 md:h-6"
                src={call_us}
                alt="call_us"
              />
              <div className="flex flex-col leading-tight">
                <p className="text-xs ">Call Us Now</p>
                <a
                  href={`tel:${contact?.phone ?? contact_details.mobile}`}
                  className="text-[#08121A] font-semibold"
                >
                  {contact?.phone ?? contact_details.mobile ?? ""}{" "}
                </a>
              </div>
            </div>

            {/* Mail */}
            <div className="flex items-center space-x-2 text-gray-600 text-sm md:text-base">
              <img
                className="w-5 h-5 md:w-6 md:h-6"
                src={mail_us}
                alt="mail_us"
              />
              <div className="flex flex-col leading-tight">
                <p className="text-xs ">Mail Us</p>
                <a
                  href={`mailto:${contact?.cooEmail ?? contact_details.cooEmail
                    }`}
                  className="text-[#08121A] font-semibold"
                >
                  { }
                  {contact?.cooEmail ?? contact_details.cooEmail}
                </a>
              </div>
            </div>

            <PrimaryButton
              text="Donate for a cause"
              onClick={handleGiveForACauseClick}
            />
          </div>

          {/* Mobile Right Side */}
          <div className="flex lg:hidden items-center space-x-3">
            <PrimaryButton
              text="Donate for a cause"
              onClick={() => { }}
              className="px-3 hidden sm:block py-1 text-sm"
            />

            <motion.button
              onClick={() => setMenuOpen(!menuOpen)}
              className="p-2 rounded-md text-gray-700 hover:bg-gray-100 transition-colors"
              animate={{ rotate: menuOpen ? 180 : 0 }}
              transition={{ duration: 0.2, ease: "easeInOut" }}
            >
              <AnimatePresence mode="wait" initial={false}>
                {menuOpen ? (
                  <motion.div
                    key="close"
                    initial={{ opacity: 0, rotate: -90 }}
                    animate={{ opacity: 1, rotate: 0 }}
                    exit={{ opacity: 0, rotate: 90 }}
                    transition={{ duration: 0.15 }}
                  >
                    <FiX className="w-6 h-6" />
                  </motion.div>
                ) : (
                  <HiOutlineMenu className="w-6 h-6" />
                )}
              </AnimatePresence>
            </motion.button>
          </div>
        </div>
      </div>

      {/* ---- Mobile Sidebar ---- */}
      <AnimatePresence>
        {menuOpen && (
          <>
            {/* Overlay */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.4 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15 }}
              className="fixed inset-0 bg-black z-40"
              onClick={() => setMenuOpen(false)}
            />

            {/* Drawer */}
            <motion.div
              ref={menuRef}
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ duration: 0.18, ease: "easeInOut" }}
              className="fixed top-0 right-0 w-[60%] sm:w-[50%] h-full bg-white shadow-xl z-50 p-6 flex flex-col"
            >
              {/* Header */}
              <div className="flex justify-end items-center mb-6">
                <button
                  className="p-2 rounded-full hover:bg-gray-200 transition"
                  onClick={() => setMenuOpen(false)}
                >
                  <FiX size={24} className="text-gray-800" />
                </button>
              </div>

              {/* Menu Items */}
              <div className="flex flex-col gap-2 flex-grow overflow-y-auto">
                {/* Profile/Login */}
                {isLoggedIn ? (
                  <button
                    onClick={() => handleNavigate("/profile")}
                    className={`text-left cursor-pointer text-base transition-all duration-200 pb-1 sm:pb-2 relative ${location.pathname === "/profile"
                        ? "font-bold text-[#02323F] bg-gradient-to-r from-[#02323F]/5 to-transparent pl-4 border-l-4 border-[#02323F]"
                        : "font-bold text-gray-700 hover:text-[#02323F] hover:bg-gray-50 pl-2"
                      }`}
                  >
                    Profile
                  </button>
                ) : (
                  <button
                    onClick={() => setIsLoginModalOpen(true)}
                    className="text-left cursor-pointer text-base font-bold text-gray-700 hover:text-[#02323F] hover:bg-gray-50 transition-all duration-200 pb-1 sm:pb-2 pl-2"
                  >
                    LOG IN
                  </button>
                )}

                {menuItems.map((item, idx) => (
                  <div key={idx} className="flex flex-col">
                    {/* Main Item */}
                    <div
                      className="flex items-center justify-between cursor-pointer"
                      onClick={() =>
                        item.hasDropdown
                          ? handleMobileDropdownToggle(idx)
                          : handleNavigate(item.path)
                      }
                    >
                      <motion.div
                        whileTap={{ scale: 0.97 }}
                        className={`text-base transition-all duration-200 flex-1 py-1 sm:py-2 relative ${isMenuItemActive(item)
                            ? "font-bold text-[#02323F] bg-gradient-to-r from-[#02323F]/5 to-transparent pl-4 border-l-4 border-[#02323F]"
                            : "font-bold text-gray-700 hover:text-[#02323F] hover:bg-gray-50 pl-2"
                          }`}
                      >
                        {item.title}
                      </motion.div>

                      {item.hasDropdown && (
                        <FaChevronDown
                          className={`text-sm transition-transform duration-200 ${mobileActiveDropdown === idx ? "rotate-180" : ""
                            } ${isMenuItemActive(item)
                              ? "text-[#02323F]"
                              : "text-gray-600"
                            }`}
                        />
                      )}
                    </div>

                    {/* Dropdown */}
                    <AnimatePresence>
                      {item.hasDropdown && mobileActiveDropdown === idx && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.2, ease: "easeInOut" }}
                          className="overflow-hidden mt-2"
                        >
                          <div className="py-2 bg-gray-50/50 rounded-md ml-2">
                            {item.title === "Campaigns" &&
                              campaigns.slice(0, 5).map((campaign) => (
                                <motion.div
                                  key={campaign._id}
                                  whileTap={{ scale: 0.97 }}
                                  onClick={() =>
                                    handleNavigate(`/campaigns/${campaign._id}`)
                                  }
                                  className={`cursor-pointer px-2 py-2 truncate whitespace-nowrap text-sm font-medium transition-all duration-200 rounded-md mx-1 relative ${isCampaignActive(campaign._id)
                                      ? "font-semibold text-[#02323F] bg-white shadow-sm border-l-3 border-[#02323F]"
                                      : "text-gray-600 hover:text-[#02323F] hover:bg-white hover:shadow-sm"
                                    }`}
                                >
                                  {campaign.name}
                                </motion.div>
                              ))}

                            {item.title === "Our Work" &&
                              services.slice(0, 5).map((service) => (
                                <motion.div
                                  key={service._id}
                                  whileTap={{ scale: 0.97 }}
                                  onClick={() =>
                                    handleNavigate(`/services/${service._id}`)
                                  }
                                  className={`cursor-pointer truncate whitespace-nowrap px-2 py-2 text-sm font-medium transition-all duration-200 rounded-md mx-1 relative ${isServiceActive(service._id)
                                      ? "font-semibold text-[#02323F] bg-white shadow-sm border-l-3 border-[#02323F]"
                                      : "text-gray-600 hover:text-[#02323F] hover:bg-white hover:shadow-sm"
                                    }`}
                                >
                                  {service.serviceName}
                                </motion.div>
                              ))}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                ))}
              </div>

              {/* Footer */}
              <div className="pt-4 border-t border-gray-100 mt-4">
                {isLoggedIn && (
                  <button
                    onClick={handleLogout}
                    className="w-full text-left cursor-pointer text-sm font-medium text-red-600 hover:text-red-700 hover:bg-red-50 transition-all duration-200 py-2 px-2 rounded-md mb-3"
                  >
                    Logout
                  </button>
                )}
                <PrimaryButton
                  text="Donate for a cause"
                  onClick={() => {
                    setMenuOpen(false);
                    handleGiveForACauseClick();
                  }}
                />
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Modals */}
      <UserLoginModal
        isOpen={isLoginModalOpen}
        setIsOpen={setIsLoginModalOpen}
      />
    </div>
  );
};

export default MidBar;
